import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type {
  AnalyticsOverviewResponseDto,
  AnalyticsRoomsResponseDto,
  AnalyticsUnit,
} from '@poker-stats/contracts';

type AnalyticsState = {
  overviewUnit: AnalyticsUnit;
  roomsUnit: AnalyticsUnit;
  overview?: AnalyticsOverviewResponseDto;
  rooms?: AnalyticsRoomsResponseDto;
  overviewLoading: boolean;
  roomsLoading: boolean;
  overviewError?: string;
  roomsError?: string;
};

const initialState: AnalyticsState = {
  overviewUnit: 'day',
  roomsUnit: 'day',
  overviewLoading: false,
  roomsLoading: false,
};

export const analyticsReducer = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    loadAnalyticsOverview(state, action: PayloadAction<AnalyticsUnit>) {
      state.overviewUnit = action.payload;
      state.overviewLoading = true;
      state.overviewError = undefined;
    },
    setAnalyticsOverview(state, action: PayloadAction<AnalyticsOverviewResponseDto>) {
      state.overview = action.payload;
      state.overviewLoading = false;
      state.overviewError = undefined;
    },
    loadAnalyticsOverviewFailed(state, action: PayloadAction<string>) {
      state.overviewLoading = false;
      state.overviewError = action.payload;
    },
    loadAnalyticsRooms(state, action: PayloadAction<AnalyticsUnit>) {
      state.roomsUnit = action.payload;
      state.roomsLoading = true;
      state.roomsError = undefined;
    },
    setAnalyticsRooms(state, action: PayloadAction<AnalyticsRoomsResponseDto>) {
      state.rooms = action.payload;
      state.roomsLoading = false;
      state.roomsError = undefined;
    },
    loadAnalyticsRoomsFailed(state, action: PayloadAction<string>) {
      state.roomsLoading = false;
      state.roomsError = action.payload;
    },
  },
});

export const {
  loadAnalyticsOverview,
  setAnalyticsOverview,
  loadAnalyticsOverviewFailed,
  loadAnalyticsRooms,
  setAnalyticsRooms,
  loadAnalyticsRoomsFailed,
} = analyticsReducer.actions;
